import Vue from "vue";
import store from "@/store";
import { http } from "@/helpers/http";
import VueRouter from "vue-router";
import Login from "../views/Login.vue";
// import Dashboard from "../views/Dashboard.vue";
import Users from "../views/Users.vue";
import PageNotFound from "../views/PageNotFound.vue";

Vue.use(VueRouter);

var routes = [
  // {
  //   path: "/",
  //   name: "Seller-Home",
  //   meta: { layout: "seller" },
  //   component: Dashboard,
  // },

  {
    path: "/login",
    name: "Login",
    meta: { layout: "auth" },
    component: Login,
  },

  {
    path: "/",
    name: "Home",
    meta: { layout: "seller" },
    component: Users,
  },

  {
    path: "/users",
    name: "Users",
    meta: { layout: "seller" },
    component: Users,
  },

  {
    path: "*",
    meta: { layout: "default" },
    name: "404",
    component: PageNotFound,
  },

];

const router = new VueRouter({
  routes,
});

// Auth Guard
router.beforeEach((to, from, next) => {
  if (needToCheckAuth(to.name)) {
    if (localStorage.getItem("_token"))
      http.defaults.headers.common["Authorization"] = `Bearer ${localStorage.getItem("_token")}`
    else next({ name: "Login" });
  }
  next();
});

function needToCheckAuth(routeName) {
  // add other pathNames that doesn't require auth
  let except = ["Login"];
  return !except.includes(routeName);
}

export default router;
